import React, { useEffect, useRef } from 'react';

import ReactGA from 'react-ga';
import {
  Container,
  MainTitle,
  SubtitleCustom,
  ButtonCustom,
  AnimationContainer,
  AnimationDiv,
} from './styles';

import svgAnim from '../../static/lineW.svg';


const SpeakToUs = ({ little }) => {
  const ref = useRef(null);

  useEffect(() => {
    ReactGA.initialize('UA-132040497-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);


  return (
    <section ref={ref}>
      <Container id="contact">
        <MainTitle little={little}>KICK-START YOUR PROJECT</MainTitle>
        <SubtitleCustom>
          Learn what it takes to create your perfect product.
        </SubtitleCustom>

        <ButtonCustom href="https://fulcrum.rocks/contact-us">Speak to us</ButtonCustom>
      </Container>
      <AnimationContainer>
        <AnimationDiv id="animationSpeak" src={svgAnim} />
      </AnimationContainer>
    </section>
  );
};

export default SpeakToUs;
